import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className={i < rating ? "star filled" : "star"}>
          ★
        </span>
      );
    }
    return stars;
  };

  const categories = [
    { name: "Boots", image: "/generated/editorial/category-boots.jpg" },
    { name: "Pumps", image: "/generated/editorial/category-pumps.jpg" },
    { name: "Mary Jane", image: "/generated/editorial/category-mary-jane.jpg" },
    { name: "Slippers & Mules", image: "/generated/editorial/category-mules.jpg" },
    { name: "Leather Flats", image: "/generated/editorial/category-flats.jpg" },
    { name: "Leather Sandals", image: "/generated/editorial/category-sandals.jpg" },
    { name: "Loafers", image: "/generated/editorial/category-loafers.jpg" },
    { name: "Sneakers", image: "/generated/editorial/category-sneakers.jpg" },
    { name: "Oxfords & Tie Shoes", image: "/generated/editorial/category-oxfords.jpg" },
    { name: "Platforms", image: "/generated/editorial/category-platforms.jpg" },
  ];

  const journalPosts = [
    {
      title: "A Simple Guide to Caring for Full-Grain Leather",
      date: "Sep 18, 2026",
      image: "/generated/editorial/journal-care.jpg",
    },
    {
      title: "Five danecay Styles for Cooler City Days",
      date: "Aug 26, 2026",
      image: "/generated/editorial/journal-winter.jpg",
    },
    {
      title: "Vintage Revival: The Timeless Charm of Retro Shoes",
      date: "Nov 19, 2025",
      image: "/generated/editorial/journal-vintage.jpg",
    },
  ];

  return (
    <div className="main">
      <section className="hero-section"></section>

      <section className="shop-by-category">
        <h2 className="section-title">SHOP BY CATEGORY</h2>
        <div className="category-grid">
          {categories.map((category, index) => (
            <Link
              to="/shop"
              key={index}
              className="category-card"
              onClick={toTop}
            >
              <img
                src={category.image}
                alt={category.name}
                className="category-image"
              />
              <span className="category-name">{category.name}</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="featured-collection">
        <h2 className="section-title">FEATURED COLLECTION</h2>
        <div className="products-grid">
          {productData.slice(0, 9).map((product) => (
            <Link
              to={`/shopDetails/${product.id}`}
              key={product.id}
              className="product-card"
              onClick={toTop}
            >
              <div className="product-image-container">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <div className="product-rating">
                  {renderStars(product.rating)}
                  <span className="review-count">({product.reviews})</span>
                </div>
                <p className="product-price">${product.price}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="about-section">
        <div className="about-content">
          <div className="about-text">
            <p className="about-brand">danecay</p>
            <h2 className="about-title">
              DESIGNER
              <br />
              HANDMADE
            </h2>
            <p className="about-description">
              danecay creates original leather footwear for everyday city life.
              Comfort begins with a balanced last, carefully selected leather,
              flexible soles and thoughtful finishing. Our Hong Kong team works
              with experienced footwear makers to refine fit, stitching and
              material combinations for each small production run. Natural
              grain, gentle tonal variation and creasing are part of genuine
              leather's character. Our goal is simple: well-made, distinctive
              shoes that feel comfortable, wear beautifully and remain fairly
              priced.
            </p>
          </div>
          <div className="about-image-container">
            <img
              src="/generated/editorial/brand-story.jpg"
              alt="danecay leather shoe craftsmanship"
              className="about-image"
            />
          </div>
        </div>
      </section>

      <section className="journal-section">
        <h2 className="section-title">FROM THE JOURNAL</h2>
        <Link to="/" className="view-all-btn" onClick={toTop}>
          VIEW ALL
        </Link>
        <div className="journal-grid">
          {journalPosts.map((post, index) => (
            <Link to="/" key={index} className="journal-card" onClick={toTop}>
              <img
                src={post.image}
                alt={post.title}
                className="journal-image"
              />
              <p className="journal-date">{post.date}</p>
              <h3 className="journal-title">{post.title}</h3>
            </Link>
          ))}
        </div>
      </section>

      <section className="retail-store-section">
        <img
          src="/generated/editorial/store.jpg"
          alt="danecay Querétaro footwear studio"
          className="retail-store-image"
        />
        <div className="retail-store-info">
          <h2 className="retail-store-title">OUR QUERÉTARO STUDIO</h2>
          <p className="retail-store-address">
            Av. del Marques 25, Rincones del marques, 76246 Santiago de Querétaro, Qro., MX
          </p>
          <p className="retail-store-hours">
            Mon - Fri, 9:30am - 6:30pm
            <br />
            Customer care by email
          </p>
        </div>
      </section>

      <section className="handmade-section">
        <div className="handmade-left">
          <img
            src="/generated/editorial/handmade.jpg"
            alt="Handmade Shoes"
            className="handmade-left-image"
          />
          <div className="handmade-info">
            <p className="handmade-brand">danecay</p>
            <h2 className="handmade-title">
              HANDMADE
              <br />
              LEATHER SHOES
            </h2>
            <p className="handmade-description">
              danecay focuses on soft leather, balanced construction and small
              details that make everyday shoes easier to live in. Each style is
              reviewed for fit, flexibility, seam placement and outsole grip by
              our Hong Kong team. We select materials for their natural feel and
              durability, then finish each pair in small runs with experienced
              makers. The result is practical footwear with a quiet, distinctive
              character rather than short-lived decoration.
            </p>
          </div>
        </div>
      </section>

      <section className="promo-section">
        <div className="promo-card promo-left">
          <img
            src="/generated/editorial/promo-season.jpg"
            alt="Seasonal danecay footwear selection"
            className="promo-image"
          />

          <p className="promo-note">
            Seasonal prices are applied automatically at checkout.
          </p>
        </div>
        <div className="promo-card promo-right">
          <img
            src="/generated/editorial/promo-fit.jpg"
            alt="Trying on danecay leather shoes"
            className="promo-image"
          />

          <p className="fit-note">
            Need help choosing a size? Email core@danecay.shop before ordering
            and our customer care team will guide you.
          </p>
        </div>
      </section>
    </div>
  );
}

export default Main;
